/**
 * SkeletonCard Component
 * 
 * This component renders a skeleton card for loading states.
 * It can be used to indicate that content is being loaded, providing a visual placeholder.
 * 
 * @author FarmCiti Team
 * @version 1.0.0
 */

import React from 'react'
import FarmCardstyles from '../../assets/stylesheets/FarmCard.module.css'
import MapCardStyles from '../../assets/stylesheets/map/MapCard.module.css'
import GalleryStyle from '../../assets/stylesheets/farm-detail/sections/Gallery.module.css'

export default function SkeletonCard({ 
  variant = 'card', 
  className = '', 
  titleClass, 
  subtitleClass,
  mapTitleClass,
  mapLocationClass,
  galleryPhotoClass
}){
  if (variant === 'header') {
    return (
      <div className={className}>
        {/* Title skeleton - uses exact same class as real title */}
        <div
          className={`${titleClass || FarmCardstyles['events-title']} ${FarmCardstyles.skeleton}`}
          style={{ width: '10rem' }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        {/* Subtitle skeleton - uses exact same class as real subtitle */}
        <div
          className={`${subtitleClass || FarmCardstyles['events-subtitle']} ${FarmCardstyles.skeleton}`}
          style={{ width: '8rem' }}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
      </div>
    )
  }else if(variant === 'map-card'){
    return (
      <div className={`${MapCardStyles["map-card"]} ${className}`}>
        <div className={MapCardStyles["map-card-image-container"]}>
          <div
            className={MapCardStyles.skeleton}
            style={{ width: '100%', height: '100%' }}
          />
          <button className={MapCardStyles["map-card-close"]}>×</button>
        </div>
        <div className={MapCardStyles["map-card-info"]}>
          {/* Title skeleton - uses exact same class as real map card title */}
          <div
            className={`${mapTitleClass || MapCardStyles['map-card-title']} ${MapCardStyles.skeleton}`}
            style={{ width: '60%' }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          {/* Location skeleton - uses exact same class as real map card location */}
          <div
            className={`${mapLocationClass || MapCardStyles['map-card-location']} ${MapCardStyles.skeleton}`}
            style={{ width: '40%' }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </div>
    )
  }
  else if (variant === 'gallery') {
    return (
      <div
        className={`${galleryPhotoClass || GalleryStyle["photo-card"]} ${GalleryStyle.skeleton} ${className}`}
      />
    )
  }

  // variant === 'card'
  return (
    <div className={`${FarmCardstyles['event-card']} ${className}`}>
      <div className={FarmCardstyles['event-card-image-container']}>
        {/* Badge skeleton - uses exact same classes as FarmCard: card-badge + list-card-badge */}
        <div className={`${FarmCardstyles['card-badge']} ${FarmCardstyles.skeleton}`}>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        {/* Image skeleton */}
        <div
          className={FarmCardstyles.skeleton}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
      {/* Title skeleton - matches h3.event-card-title with exact responsive behavior */}
      <div 
        className={`${FarmCardstyles['event-card-title']} ${FarmCardstyles.skeleton}`}
        style={{ width: '60%', height: '1.25rem' }}
      />
      {/* Location skeleton - matches p.event-card-location with exact responsive behavior */}
      <div 
        className={`${FarmCardstyles['event-card-location']} ${FarmCardstyles.skeleton}`}
        style={{ width: '40%', height: '1rem' }}
      />
    </div>
  )
}